import script from "./builderimages.vue?vue&type=script&setup=true&lang=ts"
export * from "./builderimages.vue?vue&type=script&setup=true&lang=ts"

import "./builderimages.vue?vue&type=style&index=0&id=61eb2398&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61eb2398"]])

export default __exports__